import React, { FC, useMemo } from 'react';
import { PaginationResourceLoader, useScopedSelector, Spacing, Hidden, useBreakpoint } from 'ia-react-core';
import { useTranslation } from 'react-i18next';
import Messages from './Messages';
import getApiRoot from '../../../../utils/getApiRoot';
import DeleteButton from '../../DeleteButton';
import NoResults from './NoResults';
import transformMessagesInformation from '../../utils/transformMessagesInformation/transformMessagesInformation';
import { SecuredMessagingState } from '../../../../interfaces/SecuredMessagingState';
import { MessagesInformationDto } from '../../../../interfaces/dtos/MessagesInformationDto';

export interface LoaderProps {
  messageSource: string;
  messagesPerPage: number;
}

const Loader: FC<LoaderProps> = ({ messageSource, messagesPerPage }) => {
  const isXs = useBreakpoint('xs');
  const isSent = useMemo(() => messageSource === 'Outbox', [messageSource]);
  const url = useMemo(() => `${getApiRoot()}/messages?messageSource=${messageSource}`, [messageSource]);
  const itemCount = useScopedSelector((state: SecuredMessagingState) => state?.messages?.pagination?.recordCount) || 0;
  const { t } = useTranslation('SecureMessagingPage');

  return (
    <PaginationResourceLoader
      name={`messagesResource${messageSource}`}
      centerFooter={isXs}
      url={url}
      dataDst="messages"
      requestOnLanguageChange
      CustomNoDataMessage={NoResults}
      inlineErrorMessage={false}
      buttonAlign="left"
      itemCount={itemCount}
      itemPerPage={messagesPerPage}
      offsetParam="Offset"
      limitParam="Limit"
      selectPageFromUrl
      selectPageFromUrlParam={`messagesResource${messageSource}`}
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      getDataFromResponse={(response) => (response?.data)}
      transformResponse={(messages: MessagesInformationDto) => transformMessagesInformation(messages, t)}
    >
      <PaginationResourceLoader.Content>
        <Spacing p-b={32}>
          <Messages sentMessages={isSent} />
        </Spacing>
      </PaginationResourceLoader.Content>
      <PaginationResourceLoader.FooterLeftContent>
        <Hidden xs>
          <DeleteButton messageSource={messageSource} />
        </Hidden>
      </PaginationResourceLoader.FooterLeftContent>
    </PaginationResourceLoader>
  );
};
export default Loader;
